/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscalereadingfacesweak4Inputs */



/**
* | output |
* | --- |
* | "Reading emotions from facial expressions can be hard for you — practising attention to faces will help you understand how others feel." |
*
* @param {Eisubscalereadingfacesweak4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscalereadingfacesweak4 = /** @type {((inputs?: Eisubscalereadingfacesweak4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscalereadingfacesweak4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Reading emotions from facial expressions can be hard for you — practising attention to faces will help you understand how others feel.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces te cuesta leer las emociones en la cara — entrenar la atención a los gestos te ayudará a entender mejor cómo está la otra persona.")
	return /** @type {LocalizedString} */ ("Тебе бывает сложно читать эмоции по выражению лица — тренировка внимания к мимике поможет лучше понимать состояние собеседника.")
});
export { eisubscalereadingfacesweak4 as "eiSubscaleReadingFacesWeak" }